import React, { Component } from 'react';
import {
    Badge,
    Box, Dialog, DialogActions, DialogContent,
    DialogTitle, List, ListItem, ListItemSecondaryAction, ListItemText, Radio, RadioGroup,
} from '@material-ui/core';
import Swal from 'sweetalert2';
import BreadcrumbLayout from "../../shared/components/common/breadcrumbLayout";
import CardSection from "../../shared/components/common/cardSection";
import RespondEstimateItemsSection from "../../shared/components/estimateRespond/respondEstimateItemsSection";
import RespondClienteSection from "../../shared/components/estimateRespond/respondClienteSection";
import RespondFormSection from "../../shared/components/estimateRespond/respondFormSection";
import RespondServicosModal from "../../shared/components/estimateRespond/respondServicosModal";
import { WorkshopEstimateRespondService } from './service';
import { TextField } from "@mui/material";
import Button from "@material-ui/core/Button";
import { Add } from "@material-ui/icons";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
    root: {
        backgroundColor: '#FFFFFF',
        minHeight: '100vh',
        padding: '1rem'
    },
});

class WorkshopEstimateRespondPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            estimativaAtual: null,
            cliente: null,
            sections: {
                cliente: true,
                estimativa: true,
                resposta: true
            },
            modalServicosAberto: false,
            respostaData: {
                textoResposta: '',
                valorTotal: 0,
                itensResposta: []
            },
            servicosCache: [],
            itemSelecionado: null,
            filtroServicos: '',
            mostrarDetalhesItem: false,
            itensResposta: [],
            textoResposta: '',
            valorTotal: 0,
            usuario: {
                nome: 'Técnico Responsável'
            },
            loading: false
        };
    }

    componentDidMount() {
        this.initResponderEstimativa();
    }

    componentWillUnmount() {
        this.cleanupResponderEstimativa();
    }

    initResponderEstimativa = async () => {
        try {
            // Buscar ID da estimativa da URL ou localStorage
            const estimateId = this.getEstimateId();
            if (estimateId) {
                await this.carregarEstimativa(estimateId);
                await this.carregarServicos();
            } else {
                const { currentLanguage } = this.props;
                Swal.fire(currentLanguage.bepiService.shared.shared_details_error_label, currentLanguage.bepiService.workshop.workshop_respond_id_not_found, 'error');
            }
        } catch (error) {
            console.error('Erro ao inicializar:', error);
            const { currentLanguage } = this.props;
            Swal.fire(currentLanguage.bepiService.shared.shared_details_error_label, currentLanguage.bepiService.workshop.workshop_respond_load_error, 'error');
        }
    };

    getEstimateId = () => {
        // Tenta pegar da URL primeiro
        const { match } = this.props;
        if (match?.params?.id) {
            return match.params.id;
        }

        // Tenta pegar do localStorage
        const storedId = localStorage.getItem('estimate_respond_id');
        return storedId;
    };

    carregarEstimativa = async (estimateId) => {
        try {
            const data = await WorkshopEstimateRespondService.getEstimateDetails(estimateId);

            this.setState({
                estimativaAtual: data.estimativa,
                cliente: data.cliente
            });

            // Se já existe resposta, preencher os campos
            if (data.estimativa.texto_resposta) {
                this.setState({
                    textoResposta: data.estimativa.texto_resposta,
                    valorTotal: parseFloat(data.estimativa.valor_resposta) || 0
                });
            }

        } catch (error) {
            console.error('Erro ao carregar estimativa:', error);
            throw error;
        }
    };

    carregarServicos = async () => {
        try {
            const servicos = await WorkshopEstimateRespondService.getServicesCatalog();
            this.setState({ servicosCache: servicos });
        } catch (error) {
            console.error('Erro ao carregar serviços:', error);
            const { currentLanguage } = this.props;
            Swal.fire(currentLanguage.bepiService.shared.shared_details_warning_label, currentLanguage.bepiService.workshop.workshop_respond_services_load_error, 'warning');
        }
    };

    cleanupResponderEstimativa = () => {
        this.setState({
            estimativaAtual: null,
            cliente: null,
            textoResposta: '',
            itensResposta: [],
            valorTotal: 0
        });
    };

    toggleSection = (section) => {
        this.setState(prevState => ({
            sections: {
                ...prevState.sections,
                [section]: !prevState.sections[section]
            }
        }));
    };

    abrirModalServicos = () => {
        this.setState({ modalServicosAberto: true });
    };

    fecharModalServicos = () => {
        this.setState({ modalServicosAberto: false });
    };

    handleFiltroChange = (event) => {
        this.setState({ filtroServicos: event.target.value });
    };

    getServicosFiltrados = () => {
        const { servicosCache, filtroServicos } = this.state;

        if (!filtroServicos) return servicosCache;

        return servicosCache.filter(servico =>
            servico.nome.toLowerCase().includes(filtroServicos.toLowerCase()) ||
            (servico.descricao || '').toLowerCase().includes(filtroServicos.toLowerCase()) ||
            (servico.codigo || '').toLowerCase().includes(filtroServicos.toLowerCase())
        );
    };

    selecionarItem = (item) => {
        this.setState({
            itemSelecionado: item,
            mostrarDetalhesItem: true
        });
    };

    voltarParaLista = () => {
        this.setState({
            mostrarDetalhesItem: false,
            itemSelecionado: null
        });
    };

    adicionarItem = () => {
        const { itemSelecionado, itensResposta, valorTotal } = this.state;

        if (!itemSelecionado) return;

        const qtd = 1;
        const precoEscolhido = '1';
        const preco = precoEscolhido === '1' ? itemSelecionado.valor : itemSelecionado.valor_2;
        const valorTotalItem = preco * qtd;

        const novoItem = {
            id: itemSelecionado.id,
            texto: `${itemSelecionado.nome} - ${qtd}x ${itemSelecionado.tipo} - ${WorkshopEstimateRespondService.formatarMoeda(valorTotalItem)}`,
            valor: valorTotalItem,
            tipo: itemSelecionado.tipo,
            codigo: itemSelecionado.codigo,
            quantidade: qtd,
            valor_unitario: preco
        };
    }

    handleRespostaChange = (respostaData) => {
        this.setState({ respostaData });
    };

    enviarResposta = async () => {
        const { textoResposta, valorTotal, estimativaAtual, itensResposta } = this.state;
        const { currentLanguage } = this.props;

        if (!textoResposta.trim()) {
            Swal.fire(currentLanguage.bepiService.shared.shared_details_attention_label, currentLanguage.bepiService.workshop.workshop_respond_empty_item_warning, "warning");
            return;
        }

        this.setState({ loading: true });

        try {
            console.log('Enviando resposta:', {
                estimativaId: estimativaAtual?.id,
                textoResposta: textoResposta + "\n\ncriado por: " + this.state.usuario.nome,
                valorTotal: valorTotal.toFixed(2)
            });
            // 1. Enviar resposta da estimativa
            const responseData = {
                texto_resposta: textoResposta + "\n\ncriado por: " + this.state.usuario.nome,
                valor_resposta: valorTotal,
                status: 'respondida'
            };

            await WorkshopEstimateRespondService.submitEstimateResponse(estimativaAtual.id, responseData);

            Swal.fire(currentLanguage.bepiService.shared.shared_details_success_label, currentLanguage.bepiService.workshop.workshop_respond_sent_msg, "success");
            // 2. Criar orçamento se houver itens
            if (itensResposta.length > 0) {
                const budgetData = {
                    estimate_id: estimativaAtual.id,
                    company_id: estimativaAtual.company_id,
                    valor: valorTotal,
                    observacoes: textoResposta,
                    status: 'pendente',
                    itens: itensResposta.map(item => ({
                        equip_id: null,
                        equipamento_nome: item.texto,
                        tipo_item: item.tipo,
                        codigo_interno: item.codigo,
                        nome: item.nome,
                        qtd: item.quantidade,
                        valor: item.valor_unitario
                    }))
                };

                await WorkshopEstimateRespondService.createBudget(budgetData);
            }

            Swal.fire({
                icon: "success",
                title: currentLanguage.bepiService.workshop.workshop_respond_success_alert,
                timer: 2000,
                showConfirmButton: false
            }).then(() => {
                // Navegar para lista de estimativas ou detalhes
                console.log('Navegando para detalhes...');
            });

        } catch (error) {
            console.error("Erro ao enviar resposta:", error);
            const { currentLanguage } = this.props;
            Swal.fire(currentLanguage.bepiService.shared.shared_details_error_label, error.message || currentLanguage.bepiService.workshop.workshop_respond_send_error, "error");
        } finally {
            this.setState({ loading: false });
        }
    };

    adicionarItemResposta = (novoItem) => {
        if (this.respondFormRef) {
            this.respondFormRef.adicionarItem(novoItem);
        }
    };

    renderCliente = () => {
        const { classes, cliente } = this.state;
        const { currentLanguage } = this.props;
        if (!cliente) return null;

        return (
            <Box className={classes.sectionBody}>
                <Typography><b>{currentLanguage.bepiService.shared.shared_resp_client_company}:</b> {cliente.empresa || "-"}</Typography>
                <Typography><b>{currentLanguage.bepiService.shared.shared_resp_client_name}:</b> {cliente.nome || "-"}</Typography>
                <Typography><b>{currentLanguage.bepiService.shared.shared_resp_client_phone}:</b> {cliente.telefone || "-"}</Typography>
                <Typography><b>{currentLanguage.bepiService.shared.shared_resp_client_cnpj}:</b> {cliente.cnpj || "-"}</Typography>
                <Typography><b>{currentLanguage.bepiService.shared.shared_resp_client_date}:</b> {WorkshopEstimateRespondService.formatarData(cliente.dt_criacao)}</Typography>
                <Typography><b>{currentLanguage.bepiService.shared.shared_resp_client_email}:</b> {cliente.email || "-"}</Typography>
            </Box>
        );
    };

    renderEstimativa = () => {
        const { classes, estimativaAtual } = this.state;
        const { currentLanguage } = this.props;

        if (!estimativaAtual) {
            const { currentLanguage } = this.props;
            return (
                <Typography color="textSecondary" className={classes.sectionBody}>
                    {currentLanguage.bepiService.workshop.workshop_respond_no_estimate_loaded}
                </Typography>
            );
        }

        const itens = Array.isArray(estimativaAtual.itens) ? estimativaAtual.itens : [];

        return (
            <Box className={classes.sectionBody}>
                <Typography variant="subtitle2" gutterBottom>
                    {currentLanguage.bepiService.shared.shared_quotation_table_status}: <span style={{
                        color: estimativaAtual.status === 'aguardando equipamento' ? '#ff9800' : '#4caf50',
                        fontWeight: 'bold'
                    }}>
                        {estimativaAtual.status}
                    </span>
                </Typography>

                {estimativaAtual.endereco && (
                    <Typography variant="body2" gutterBottom>
                        <b>{currentLanguage.bepiService.shared.shared_clients_address_label}:</b> {estimativaAtual.endereco}
                    </Typography>
                )}

                <List>
                    {itens.length > 0 ? (
                        itens.map((item, index) => (
                            <ListItem
                                key={index}
                                className={classes.listItem}
                                onClick={() => this.abrirModalServicos(item.servico_id)}
                            >
                                <ListItemText
                                    primary={item.servico}
                                    secondary={item.obs}
                                />
                                <ListItemSecondaryAction>
                                    <Badge badgeContent="+" color="primary">
                                        <Add />
                                    </Badge>
                                </ListItemSecondaryAction>
                            </ListItem>
                        ))
                    ) : (
                        <ListItem>
                            <ListItemText primary={currentLanguage.bepiService.workshop.workshop_respond_no_items_msg} />
                        </ListItem>
                    )}
                </List>
            </Box>
        );
    };

    renderResposta = () => {
        const { classes, textoResposta, valorTotal, loading } = this.state;
        const { currentLanguage } = this.props;

        return (
            <Box className={classes.sectionBody}>
                <TextField
                    fullWidth
                    multiline
                    rows={4}
                    label={currentLanguage.bepiService.workshop.workshop_respond_obs_label}
                    value={textoResposta}
                    onChange={(e) => this.setState({ textoResposta: e.target.value })}
                    placeholder={currentLanguage.bepiService.workshop.workshop_respond_obs_placeholder}
                    style={{ marginBottom: 16 }}
                />

                <TextField
                    fullWidth
                    type="number"
                    label={currentLanguage.bepiService.workshop.workshop_respond_total_value_label}
                    value={valorTotal}
                    onChange={(e) => this.setState({ valorTotal: parseFloat(e.target.value) || 0 })}
                    inputProps={{ step: "0.01" }}
                    style={{ marginBottom: 16 }}
                />

                <Button
                    variant="contained"
                    color="primary"
                    onClick={this.enviarResposta}
                    disabled={loading}
                >
                    {loading ? currentLanguage.bepiService.shared.shared_details_uploading_btn : currentLanguage.bepiService.workshop.workshop_respond_finish_btn}
                </Button>
            </Box>
        );
    };

    renderModalServicos = () => {
        const { classes, modalServicosAberto, mostrarDetalhesItem, itemSelecionado, filtroServicos } = this.state;
        const servicosFiltrados = this.getServicosFiltrados();
        const { currentLanguage } = this.props;

        return (
            <Dialog
                open={modalServicosAberto}
                onClose={this.fecharModalServicos}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>
                    {mostrarDetalhesItem ? currentLanguage.bepiService.workshop.workshop_respond_item_details_title : currentLanguage.bepiService.workshop.workshop_respond_select_service_title}
                </DialogTitle>

                <DialogContent className={classes.modalContent}>
                    {!mostrarDetalhesItem ? (
                        <Box>
                            <TextField
                                fullWidth
                                label={currentLanguage.bepiService.workshop.workshop_respond_filter_label}
                                value={filtroServicos}
                                onChange={this.handleFiltroChange}
                                className={classes.filterField}
                                placeholder={currentLanguage.bepiService.workshop.workshop_respond_filter_placeholder}
                            />

                            <List>
                                {servicosFiltrados.map(servico => (
                                    <ListItem
                                        key={servico.id}
                                        button
                                        onClick={() => this.selecionarItem(servico)}
                                    >
                                        <ListItemText
                                            primary={`${servico.nome} (${servico.tipo})`}
                                            secondary={`${servico.descricao} - ${WorkshopEstimateRespondService.formatarMoeda(servico.valor)}`}
                                        />
                                    </ListItem>
                                ))}
                            </List>
                        </Box>
                    ) : (
                        <Box>
                            <Typography variant="h6" gutterBottom>
                                {itemSelecionado?.nome} ({itemSelecionado?.tipo})
                            </Typography>

                            <Typography variant="body2" color="textSecondary" paragraph>
                                {itemSelecionado?.descricao}
                            </Typography>

                            <TextField
                                fullWidth
                                label={currentLanguage.bepiService.workshop.workshop_respond_quantity_label}
                                type="number"
                                defaultValue={1}
                                inputProps={{ min: 1 }}
                                style={{ marginBottom: 16 }}
                            />

                            <RadioGroup name="precoOption" defaultValue="1">
                                <FormControlLabel
                                    value="1"
                                    control={<Radio />}
                                    label={`Preço 1: ${WorkshopEstimateRespondService.formatarMoeda(itemSelecionado?.valor || 0)}`}
                                />
                                <FormControlLabel
                                    value="2"
                                    control={<Radio />}
                                    label={`Preço 2: ${WorkshopEstimateRespondService.formatarMoeda(itemSelecionado?.valor_2 || 0)}`}
                                />
                            </RadioGroup>
                        </Box>
                    )}
                </DialogContent>

                <DialogActions>
                    {mostrarDetalhesItem ? (
                        <>
                            <Button onClick={this.voltarParaLista} color="secondary">
                                {currentLanguage.bepiService.shared.shared_details_cancel_btn}
                            </Button>
                            <Button onClick={this.adicionarItem} color="primary" variant="contained">
                                {currentLanguage.bepiService.workshop.workshop_respond_add_btn}
                            </Button>
                        </>
                    ) : (
                        <Button onClick={this.fecharModalServicos} color="primary">
                            {currentLanguage.bepiService.shared.shared_equip_form_close_btn}
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        );
    };

    render() {
        const { sections, cliente, estimativaAtual, servicosCache, modalServicosAberto, respostaData } = this.state;
        const { classes } = this.props;
        const { currentLanguage } = this.props
        const breadcrumbItems = [
            { label: currentLanguage.bepiService.shared.shared_breadcrumb_home, path: '/bepi/workshop' },
            // { label: currentLanguage.bepiService.workshop.workshop_breadcrumb_quotations, path: '/bepi/workshop/quotations' },
            { label: currentLanguage.bepiService.workshop.workshop_breadcrumb_estimate_respond },
        ];


        return (
            <BreadcrumbLayout
                title={currentLanguage.bepiService.workshop.workshop_breadcrumb_estimate_respond}
                breadcrumbItems={breadcrumbItems}
                currentLanguage={currentLanguage}
                showBackButton
            >
                <Box className={classes.root}>
                    <CardSection
                        title={currentLanguage.bepiService.workshop.workshop_respond_client_data_title}
                        expanded={sections.cliente}
                        onToggle={() => this.toggleSection('cliente')}
                    >
                        <RespondClienteSection cliente={cliente} currentLanguage={currentLanguage} />
                    </CardSection>

                    <CardSection
                        title={currentLanguage.bepiService.workshop.workshop_respond_estimate_data_title}
                        expanded={sections.estimativa}
                        onToggle={() => this.toggleSection('estimativa')}
                    >
                        <RespondEstimateItemsSection
                            estimativa={estimativaAtual}
                            onAbrirModalServicos={this.abrirModalServicos}
                            currentLanguage={currentLanguage}
                        />
                    </CardSection>

                    <CardSection
                        title={currentLanguage.bepiService.workshop.workshop_respond_admin_reply_title}
                        expanded={sections.resposta}
                        onToggle={() => this.toggleSection('resposta')}
                    >
                        <RespondFormSection
                            ref={ref => this.respondFormRef = ref}
                            modo="workshop"
                            respostaInicial={respostaData}
                            onRespostaChange={this.handleRespostaChange}
                            onEnviarResposta={this.enviarResposta}
                            currentLanguage={currentLanguage}
                        />
                    </CardSection>

                    <RespondServicosModal
                        open={modalServicosAberto}
                        servicosCache={servicosCache}
                        onFechar={this.fecharModalServicos}
                        onAdicionarItem={this.adicionarItemResposta}
                        currentLanguage={currentLanguage}
                    />
                </Box>
            </BreadcrumbLayout>
        );
    }
}

export default withStyles(styles)(WorkshopEstimateRespondPage);

